import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { InspectionEquipment } from '../../class/inspection-equipment';

@Injectable()
export class InspectionEquipmentService extends WebService {

    public getInspectionEquipment (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String(''));

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/inspection-equipments?${params}`, options);
    }

    public newInspectionEquipment(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/inspection-equipments`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateInspectionEquipment(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/inspection-equipments/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteInspectionEquipment(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/inspection-equipments/${id}`, { headers: this.headers } );
    }

    public infoInspectionEquipment(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/inspection-equipments?id=${id}`,  { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/inspection-equipment/inspection-equipment.service.ts